var isNumber = require('../type/is-number');

var isInteger = Number.isInteger ? Number.isInteger : function (num) {
  return isNumber(num) && num % 1 === 0;
};
module.exports = isInteger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-integer.js
// module id = 297
// module chunks = 0 1 2